import { render, staticRenderFns } from "./DeleteCourseModal.vue?vue&type=template&id=e02f66e0"
import script from "./DeleteCourseModal.vue?vue&type=script&lang=js"
export * from "./DeleteCourseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports